<template>
  <div>
    <div class="button-group">
      <!-- Launch Button -->
      <b-button
        type="is-primary"
        :disabled="!aspirations.trim()"
        @click="showModal = true"
      >
        Build My Profile!
      </b-button>
      <b-button
        type="is-secondary"
        @click="showModal = true"
      >
        Skip
      </b-button>
    </div>
    <!-- Modal -->
    <b-modal
      v-model="showModal"
      has-modal-card
      trap-focus
    >
      <div class="modal-card" v-if="showConsentMessage">
        <section class="modal-card-body">
          <h1 class="title">Get AI-Powered Insights from Your Data</h1>
          <p>By submitting your data, you acknowledge and agree to the following:</p>
          <p>We will use AI to analyze your data and provide personalized career insights and job match recommendations. Your information will be handled responsibly (we do not sell your data or share it without your permission). We may use anonymized, aggregated data to improve our product and services over time.</p>
          <p>You can request to have your data deleted at any time by contacting us.</p>
          <p>By continuing, you consent to Teamwrkr analyzing your data to support your career journey.</p>
          <!-- Action Buttons -->
          <div class="button-group">
            <b-button type="is-primary" @click="consentAgree">Acknowledge</b-button>
            <b-button type="is-secondary" @click="showModal = false">Close</b-button>
          </div>
        </section>
      </div>

      <div class="modal-card" v-else>
        <section class="modal-card-body">
          <h1 class="title">Next Steps</h1>
          <p>Now we need to verify your profile, please confirm these details and submit to join the Teamwrkr platform</p>
          <b-field label="First Name" label-position="on-border">
            <b-input v-model="userForm.firstName" placeholder="Enter your first name"></b-input>
          </b-field>
          <b-field label="Last Name" label-position="on-border">
            <b-input v-model="userForm.lastName" placeholder="Enter your last name"></b-input>
          </b-field>
          <b-field label="Email" label-position="on-border">
            <b-input v-model="userForm.email" type="email" placeholder="Enter your email"></b-input>
          </b-field>

          <!-- Action Buttons -->
          <div class="button-group">
            <b-button type="is-primary" :loading="loading" :disabled="!!passwordError" @click="submit">Submit</b-button>
          </div>
          <p v-if="error" class="error-msg">{{ error }}</p>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { useAnalyzeStore } from '../stores/analyzeStore'
import { useUserStore } from '@/stores/userStore';

export default {
  name: 'ConsentModal',
  props: {
    compensation: {
      min: Number,
      max: Number,
    },
    aspirations: String,
  },
  data() {
    return {
      showModal: false,
      showConsentMessage: true,
      loading: false,
      error: '',
      userForm: {
        _id: '',
        firstName: '',
        lastName: '',
        email: '',
      }
    };
  },
  created() {
    this.userStore = useUserStore()
    if (this.$route.query.user) {
      this.fetchAndRehydrateUserData(this.$route.query.user).then(userData => {
        if (userData) {
          this.analyzeStore.setUser(userData);
        }
      });
    }
    console.log('analyze store:', this.analyzeStore.user)
  },
  computed: {
    analyzeStore() {
      return useAnalyzeStore()
    },
  },
  methods: {
    async fetchAndRehydrateUserData(userId) {
      console.log('Fetching user data for ID:', userId);
      try {
        const response = await this.axios.get(
          `${process.env.VUE_APP_API_URL}/users/${userId}`
        );
        return response.data;
      } catch (err) {
        console.error('Error fetching user data:', err);
        return null;
      }
    },
    consentAgree() {
      this.userForm._id = this.analyzeStore.user?._id || '';
      this.userForm.firstName = this.analyzeStore.user?.firstName || '';
      this.userForm.lastName = this.analyzeStore.user?.lastName || '';
      this.userForm.email = this.analyzeStore.user?.email.toLowerCase() || '';
      this.userForm.password = '';
      this.showConsentMessage = false;
      console.log('Analyze Store:', this.analyzeStore);
    },
    async submit() {
      this.loading = true;
      this.error = '';
      console.log("submitting", this.userForm);
      console.log("ANALYZE STORE (analysis):", this.analyzeStore.analysis);
      console.log("ANALYZE STORE (resumeText):", this.analyzeStore.resumeText);
      console.log("ANALYZE STORE (workHistory):", this.analyzeStore.workHistory);
      console.log("ANALYZE STORE (aspirations):", this.aspirations);
      console.log("ANALYZE STORE (compensation):", this.compensation);
      const payload = {
        user: this.userForm,
        resumeText: this.analyzeStore.resumeText,
        analysis: this.analyzeStore.analysis,
        workHistory: this.analyzeStore.workHistory,
        aspirations: this.aspirations,
        compensationRange: this.compensation,
      };
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/finalize-onboarding`,
          payload,
          { headers: { Authorization: `Onboarding ${this.analyzeStore.onboardingToken}` } }
        );
        console.log("USER CREATED:", response.data);
        this.userStore.setUser(response.data);
        this.analyzeStore.clearOnboarding();
        this.$router.push('/next-steps');
      } catch (err) {
        this.error = err?.response?.data?.message || 'Something went wrong. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.2rem;
}

.b-button {
  border-radius: 0.7rem;
  font-weight: 700;
  font-size: 1.08rem;
  border: none;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.07);
  &.is-primary {
    background: $color-primary;
    color: $color-surface;
    transition: background 0.18s, color 0.18s;
    &:hover, &:focus {
      background: $color-accent;
      color: $color-surface;
    }
  }
  &.is-secondary {
    background: $color-surface-soft;
    color: $color-primary;
    &:hover, &:focus {
      background: $color-border;
      color: $color-text;
    }
  }
}
</style>
